// extracted by mini-css-extract-plugin
module.exports = {"chat":"styles_chat__24piY","inputDescription":"styles_inputDescription__1KkWw"};